import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-portabilidades',
  templateUrl: './portabilidades.component.html',
  styleUrls: ['./portabilidades.component.scss']
})
export class PortabilidadesComponent implements OnInit {

  private itemsCol:    AngularFirestoreCollection<any>;
  public  items:       Observable<any>;
  public  dataSource = new MatTableDataSource<any>();

  public displayedColumns = ["nroTelefono", "simcard", "ruta", "circuito", "punto-venta", "vendedor", "fechaSalida", "operador" ];
  
  @ViewChild(MatSort, {static: true}) sort: MatSort;  
  filter: string = "";
  tipoFiltro: string = "id";

  constructor(private afFirestore: AngularFirestore,) {    
    this.itemsCol = afFirestore.collection<any>("metas", ref=>ref.where("salida", "==", true).orderBy("fechaSalida", "desc").limit(100));
    this.items    = this.itemsCol.valueChanges();
  }

  ngOnInit() {
    this.items.subscribe(
      data => {
        this.dataSource = new MatTableDataSource<any>(data);        
        this.dataSource.sort      = this.sort;
        this.dataSource.filter    = this.filter; 
      }
    );
  }

  trackByUid(index, item) {
    return item.nroTelefono;
  }

  applyFilter() {    
    this.filter = this.filter.trim().toLowerCase();
    console.log("applyFilter("+this.tipoFiltro+","+this.filter+")");
    if( this.filter.length > 0 ){      
      if( this.tipoFiltro === "punto-venta" || this.tipoFiltro === "vendedor" ){
        console.log("sin limite... en teoria!");
        this.itemsCol = this.afFirestore.collection<any>("metas", 
          ref => ref.where("salida", "==", true).where(this.tipoFiltro, '==', this.filter)
        );
      }
      else{
        this.itemsCol = this.afFirestore.collection<any>("metas", 
          ref => ref.where("salida", "==", true)
            .where(this.tipoFiltro, '>=', this.filter)
            .where(this.tipoFiltro, '<=', this.filter+'\uf8ff')            
            .limit(100)
        );
      }      
    }
    else{
      this.itemsCol = this.afFirestore.collection<any>("metas", ref=>ref.where("salida", "==", true).orderBy("fechaSalida", "desc").limit(100));
    }
    this.items  = this.itemsCol.valueChanges();
    this.items.subscribe(
      data => {
        console.table(data);
        this.dataSource = new MatTableDataSource<any>(data);        
        this.dataSource.sort      = this.sort;
        this.dataSource.filter    = this.filter; 
      }
    );
  }

}
